<script context="module">
  import { subscribe } from '../helpers/subscribe'

  export class CheckboxHandler {
    constructor(checked) {
      this.data = {
        checked
      }
    }
    action() {
      this.data.checked = this.data.checked ? false : true
      this._store.set(this.data)
    }
    store() {
      return this._store = subscribe()
    }
  }
</script>

<script>
  export let label, name, store, onclick
</script>

<input id={name} name={name} value={$store.checked ? 1 : 0} type="hidden">
<div class="box">
  <label class="{`${$store.checked ? 'checked' : 'unchecked'}`}" for="{name}" on:click={onclick} on:keydown={null}>
    <div class="icon">
      <div class="checkbox"></div>
      <ion-icon class="check" name="checkmark-outline"></ion-icon>
      <!-- <ion-icon class="check" name="radio-button-on-outline"></ion-icon> -->
    </div>
    <span>
      {@html label}
    </span>
  </label>
</div>

<style lang="scss">
  .box {
    display: inline-block;
  }
  label {
    cursor: pointer;
    display: flex;
    // align-items: center;
    // height: 24px;
    color: #791c58;
    font-size: 16px;
    font-family: 'myriad-pro', sans-serif;
    font-weight: 500;
    font-style: normal;
  }
  ion-icon {
    cursor: pointer;
    display: none;
    width: 30px;
    height: 30px;
    color: #ddd;
  }
  .icon {
    position: relative;
    margin-right: 12px;
  }
  .check {
    position: absolute;
    top: -9px;
    left: -2px;
  }
  .checkbox {
    width: 18px;
    height: 18px;
    background-color: transparent;
    border: 2px solid #fff;
    border-radius: 3px;
    background-color: #e73780;
  }
  .checked {
    .check {
      display: inline-block;
    }
  }
  .unchecked {
    .check {
      display: none;
    }
  }
</style>